import { createContext } from 'react';

import { RegionSummaryItem } from '@totem/components/portfolio/regions/types';

interface Context {
  id: string;
  loading: boolean;
  region: RegionSummaryItem;
}

export default createContext<Context>({
  id: '',
  loading: false,
  region: null,
});
